import { useContext } from 'react';
import {
  LocalizationContext,
  LocalizationContextProps,
} from '../contexts/localization/LocalizationContext';

export const useLocalization = (): LocalizationContextProps => {
  const context = useContext(LocalizationContext);
  return context;
};
